// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".secunity .el-tabs.el-tabs--top.el-tabs--border-card .el-tabs__content #pane-0 .el-row[data-v-9b4483d4]{margin:15px}.secunity .el-tabs.el-tabs--top.el-tabs--border-card .el-tabs__content #pane-0 .el-row .el-col.el-col-1 span[data-v-9b4483d4]{color:#409eff}", ""]);
// Exports
module.exports = exports;
